import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  FormFeedback,
  Modal,
  Button,
} from "reactstrap"

import Select from "react-select"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import { Link, useHistory, useParams } from "react-router-dom"

// import images
import logo from "assets/images/logo-large.png"

import "../../../assets/scss/custom/style.css"

import Autocomplete from "@material-ui/lab/Autocomplete"
import Box from "@material-ui/core/Box"
import { TextField } from "@material-ui/core"
import Snackbars from "../../../Utils/Snackbars"
import useRequestsWOAccessToken from "../../../Utils/useRequestsWOAccessToken"
import i18next from "i18next"
import zxcvbn from "zxcvbn"
import { gtmPushEvent, getConsentContext, getOpenAiAttribution } from "../../../Utils/gtm";
import { trackSignupStarted } from "../../../Utils/segment";

// Track signup_started only once per page load
let signupStartedFired = false;

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: "#ffffff",
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? "#036B41"
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? "#fff"
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ":active": {
      ...styles[":active"],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const Register = props => {
  //meta title
  document.title = i18next.t("Register PG document title")
  const history = useHistory()
  const { getRequestWOAccessToken, postRequestWOAccessToken } =
    useRequestsWOAccessToken()
  const { referral_code } = useParams()

  const [AlertData, setAlertData] = React.useState({
    variant: "",
    message: "",
  })
  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData(AlertData => ({
        ...AlertData,
        variant: "",
        message: "",
      }))
    }, 5000)
  }

  const calculatePasswordStrength = (password) => {
      let score = 0;

      if (!password) return 0;

      // Length rules
      if (password.length >= 8) score += 1;

      // Contains char
      if (/[a-zA-Z]/.test(password)) score += 1;

      // Contains number
      if (/\d/.test(password)) score += 1;

      // Contains special char
      if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) score += 1;

      // Normalize to 0–4 range
      if (score <= 2) return 1;   // Weak
      if (score <= 3) return 2;   // Fair
      if (score >= 4) return 3;  // Strong
      if (score >= 5) return 4;   // Very strong

      return 0;
    };

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email(i18next.t("Please enter a valid email!"))
        .max(255)
        .required(i18next.t("Register PG Email is required")),
      password: Yup.string()
        .matches(
          /[a-zA-Z]/,
          i18next.t("Register PG Password must contain at least one letter"),
        )
        .matches(
          /\d/,
          i18next.t(
            "Register PG Password must contain at least one numeric character",
          ),
        )
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          i18next.t(
            "Register PG Password must contain at least one special character",
          ),
        )
        .required(i18next.t("Register PG Password is required"))
        .min(8, i18next.t("Register PG Password must be at least 8 characters"))
        .max(
          20,
          i18next.t("Register PG Password must be at most 20 characters"),
        ),
    }),
    onSubmit: async values => {
      try {
        let submit1 = document.getElementById("submit1")
        submit1.disabled = true
        submit1.textContent = i18next.t("Processing...")

        const urlParams = new URLSearchParams(window.location.search);
        
        // Track all attribution parameters
        const attributionParams = [
            'utm_source', 'utm_medium', 'utm_campaign', 
            'utm_term', 'utm_content', 'gclid', 'fbclid', 'ref'
        ];

        const capturedParams = {};
        let hasAttributionData = false;

        attributionParams.forEach(param => {
            const value = urlParams.get(param);
            if (value) {
                localStorage.setItem(param, value);
                capturedParams[param] = value;
                hasAttributionData = true;
            } else {
                // Fallback: read from localStorage (captured on earlier page load)
                const stored = localStorage.getItem(param);
                if (stored) {
                    capturedParams[param] = stored;
                    hasAttributionData = true;
                }
            }
        });

        // Store first touch data if not already present
        let first_touch_url = '';
        let first_touch_at = '';
        let landing_url = '';
        let first_site_landing_url = '';
        if (!localStorage.getItem('first_touch_at')) {
          const currentUrl = window.location.href;

          first_touch_url = document.referrer || 'direct';
          first_touch_at = new Date().toISOString();
          landing_url = currentUrl;
          first_site_landing_url = currentUrl;

          localStorage.setItem('first_touch_url', first_touch_url);
          localStorage.setItem('first_touch_at', first_touch_at);
          localStorage.setItem('landing_url', landing_url);
          localStorage.setItem('first_site_landing_url', first_site_landing_url);

          hasAttributionData = true;
        } else {
          first_touch_url = localStorage.getItem('first_touch_url') || '';
          first_touch_at = localStorage.getItem('first_touch_at') || '';
          landing_url = localStorage.getItem('landing_url') || '';
          first_site_landing_url = localStorage.getItem('first_site_landing_url') || '';
        }

        // Add these to the attribution event
        capturedParams.first_touch_url = first_touch_url;
        capturedParams.first_touch_at = first_touch_at;
        capturedParams.landing_url = landing_url;
        capturedParams.first_site_landing_url = first_site_landing_url;

        // Forward ad consent snapshot so the API can persist it and attach
        // ad_user_data_consent / ad_personalization_consent to Segment events.
        const consentContext = getConsentContext();
        if (consentContext) {
            capturedParams.consent = JSON.stringify(consentContext);
            hasAttributionData = true;
        }

        // Forward OpenAI ad attribution (__oppref / __obref) when present so the
        // API can persist it and attach it to registration_completed.
        const openAiAttribution = getOpenAiAttribution();
        Object.entries(openAiAttribution).forEach(([key, value]) => {
            capturedParams[key] = value;
            hasAttributionData = true;
        });

        // Send attribution data to GTM if any exists
        if (hasAttributionData) {
            gtmPushEvent({
                event: 'attribution_capture',
                page_url: window.location.href,
                ...capturedParams
            });
        }

        // Generate and store session ID if not exists
        if (!sessionStorage.getItem('session_id')) {
            sessionStorage.setItem('session_id', Date.now() + '_' + Math.random().toString(36).substr(2, 9));
        }

        const jsonpar = JSON.stringify({
          email: values.email,
          password: values.password,
          preferred_language: PreferredLanguage,
          referral_code: referral_code,
          collaborator_referral_code: "",
          captured_params: capturedParams,
        })
        const res = await postRequestWOAccessToken(
          "signup-email-password",
          jsonpar,
        )
        if (res && res.code === 200) {
          let originalText = res.data

          history.push("/email-verification", {
            id: originalText,
            email: values.email,
            collaborator_referral_code: "",
            referral_code: referral_code,
            code: 200,
            status: "success",
            message: res.message,
          })
        } else {
          setAlertData(AlertData => ({
            ...AlertData,
            variant: "error",
            message: res.message,
          }))
        }
        resetAlertData()

        submit1.disabled = false
        submit1.textContent = i18next.t("Continue")
      } catch (error) {
        console.error("Error : ", error)
      }
    },
  })

  const [passwordStrength, setPasswordStrength] = useState(0) // 0 to 4

  // Function to get color based on strength
  const getStrengthColor = score => {
    switch (score) {
      case 0:
      case 1:
        return "red"
      case 2:
        return "yellowgreen"
      case 3:
        return "green"
      case 4:
        return "green"
      default:
        return "transparent"
    }
  }

  // Function to get label
  const getStrengthLabel = score => {
    switch (score) {
      case 0:
        return i18next.t("Unsafe")
      case 1:
        return i18next.t("Unsafe")
      case 2:
        return i18next.t("Fair")
      case 3:
        return i18next.t("Secure")
      case 4:
        return i18next.t("Secure")
      default:
        return ""
    }
  }

  const [PreferredLanguage, setPreferredLanguage] = React.useState("eng")
  const onChangePreferredLanguage = e => {
    i18next.changeLanguage(e.target.value)
    setPreferredLanguage(e.target.value)
    localStorage.setItem("I18N_LANGUAGE", e.target.value)
  }
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE")
    if (!language) setPreferredLanguage("sp")
    else setPreferredLanguage(language)

    if (referral_code) {
      validation1.setValues({
        ...validation1.values,
        referral_code: referral_code,
      })
    }
  }, [])

  return (
    <React.Fragment>
      {AlertData.message !== "" ? (
        <Snackbars variant={AlertData.variant} message={AlertData.message} />
      ) : (
        ""
      )}
      <div className="p-0 container-fluid">
        <select
          className="form-select top-right-lang"
          name="preferred_language"
          value={PreferredLanguage}
          onChange={e => onChangePreferredLanguage(e)}
        >
          <option value={"eng"}>English</option>
          <option value={"sp"}>Spanish</option>
        </select>
        <Row className="g-0">
          <Col className="LeftImg">
            <div className="auth-full-page-content p-3 bg-white">
              <div className="w-100">
                <div className="d-flex flex-column h-100">
                  <div className="mb-4 mb-md-5">
                    <Link to="/" className="auth-logo-light">
                      <div className="mb-1">
                        <span className="">
                          {" "}
                          <img src={logo} alt="" height="60" />{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="my-auto">
                    <div className="text-primary p-4">
                      <h2 className="text-black">
                        {i18next.t("Create your account")}
                      </h2>
                      <p className="text-black" style={{ fontSize: '17px' }}>
                        {i18next.t("Takes only a few minutes")}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="p-2">
                        <div className="form-horizontal">
                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Register PG Email")} :
                                </Label>
                                <Input
                                  name="email"
                                  type="email"
                                  placeholder={i18next.t(
                                    "Register PG Enter email",
                                  )}
                                  onChange={validation1.handleChange}
                                  onFocus={() => {
                                    if (!signupStartedFired) {
                                      signupStartedFired = true;
                                      trackSignupStarted(new URLSearchParams(window.location.search).get('ref') || null);
                                    }
                                  }}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.email || ""}
                                  invalid={
                                    validation1.touched.email &&
                                    validation1.errors.email
                                      ? true
                                      : false
                                  }
                                />
                                {validation1.touched.email &&
                                validation1.errors.email ? (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.email}
                                  </FormFeedback>
                                ) : null}
                              </div>
                            </Col>
                          </div>

                          <div className="row">
                            <Col md={12}>
                              <div className="mb-3">
                                <Label className="form-label">
                                  {i18next.t("Register PG Password")} :
                                </Label>
                                <Input
                                  name="password"
                                  type="password"
                                  placeholder={i18next.t(
                                    "Register PG Enter password",
                                  )}
                                  onChange={e => {
                                    validation1.handleChange(e)
                                    const score = calculatePasswordStrength(e.target.value);
                                    setPasswordStrength(score);
                                  }}
                                  onBlur={validation1.handleBlur}
                                  value={validation1.values.password || ""}
                                  invalid={
                                    validation1.touched.password &&
                                    validation1.errors.password
                                      ? true
                                      : false
                                  }
                                />
                                {validation1.touched.password &&
                                validation1.errors.password ? (
                                  <FormFeedback type="invalid">
                                    {validation1.errors.password}
                                  </FormFeedback>
                                ) : null}

                                <small className="text-muted d-block mt-1">
                                  {i18next.t(
                                    "Password validation"
                                  )}
                                  
                                </small>

                                {/* Password Strength Meter */}
                                <div style={{ marginTop: "5px" }}>
                                  <div
                                    style={{
                                      height: "6px",
                                      width: "100%",
                                      backgroundColor: "#ddd",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: "6px",
                                        width: `${(passwordStrength / 4) * 100}%`,
                                        backgroundColor:
                                          getStrengthColor(passwordStrength),
                                        borderRadius: "3px",
                                        transition: "width 0.3s",
                                      }}
                                    ></div>
                                  </div>
                                  <small
                                    style={{
                                      color: getStrengthColor(passwordStrength),
                                    }}
                                  >
                                    {getStrengthLabel(passwordStrength)}
                                  </small>
                                </div>
                              </div>
                            </Col>
                          </div>

                          <div className="mt-4 d-grid">
                            <Button
                              id="submit1"
                              onClick={e => {
                                e.preventDefault()
                                validation1.handleSubmit()
                                return false
                              }}
                              data-toggle="modal"
                              data-target="#myModal"
                              className="btn btn-primary btn-block"
                            >
                              {" "}
                              {i18next.t("Continue")}{" "}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 mt-md-5 text-center">
                    <p className="footer-text-color">
                      {" "}
                      {i18next.t("Register PG Already have an account?")} &nbsp;
                      <Link
                        to="/login"
                        className="font-weight-medium text-underline"
                      >
                        {i18next.t("Login")}
                      </Link>{" "}
                    </p>
                    <p className="footer-text-color">
                      {" "}
                      © {new Date().getFullYear()} Tokenized Green.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col className="rightImg">
            <div className="bgLogin"></div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default Register
